import { render } from "./woodenFish.vue?vue&type=template&id=53209638&scoped=true"
import script from "./woodenFish.vue?vue&type=script&lang=js"
export * from "./woodenFish.vue?vue&type=script&lang=js"

import "./woodenFish.vue?vue&type=style&index=0&id=53209638&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53209638"]])

export default __exports__